"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.64 10"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.44.61v7.3L4.58,6.79a.63.63,0,0,1,.88,0,.59.59,0,0,1,0,.86L3.26,9.82a.63.63,0,0,1-.88,0L.18,7.65a.6.6,0,0,1,0-.86.63.63,0,0,1,.88,0L2.2,7.91V.61A.61.61,0,0,1,2.82,0,.61.61,0,0,1,3.44.61Z"
  }));
};

exports["default"] = _default;